/**
 * @file src/pages/invoice-management-hub/components/ActionMenuItem.jsx
 * @description A single menu row inside the per-row Actions dropdown.
 *
 * Pure presentational. Stops propagation so a click never bubbles up
 * to the parent dropdown's outside-click closer.
 *
 * Removed from original:
 *  - console.log fallback for missing onClick — silent no-op is cleaner
 */

import React from "react";
import Icon from "components/AppIcon";

const ActionMenuItem = ({ icon, label, onClick, className = "" }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) onClick(e);
  };

  return (
    <button
      onClick={handleClick}
      className={`w-full px-4 py-2 text-left text-sm text-popover-foreground hover:bg-muted flex items-center gap-3 transition-colors ${className}`}
    >
      <Icon name={icon} size={16} />
      {label}
    </button>
  );
};

export default ActionMenuItem;